import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { OverflowCollapse } from "../overflow-collapse/OverflowCollapse";
import { MenuButton } from "../menu-button/MenuButton";
import * as Styled from "./ButtonGroup.styled";
export const ButtonGroup = forwardRef((props, ref) => {
    const { attachedTo, children, isDistributed, isJoined, overflowLabel, overflowPriority = "primary", overflowRender, shouldCollapseOverflow, ...otherProps } = props;
    const renderOverflow = (overflowChildren) => {
        const actions = overflowChildren.map((child) => {
            if (!React.isValidElement(child)) {
                return {};
            }
            return {
                label: child.props.children,
                onClick: child.props.onClick ? child.props.onClick : () => { }
            };
        });
        return (_jsx(MenuButton, { priority: overflowPriority, actions: actions, placement: "bottom-end", children: overflowLabel }));
    };
    const activeColorScheme = useActiveColorScheme();
    return (_jsx(Styled.ButtonGroup, { "data-testid": "ButtonGroup", ref: ref, attachedTo: attachedTo, isDistributed: isDistributed, isJoined: isJoined, hasSingleChild: React.Children.toArray(children).filter((child) => React.isValidElement(child)).length === 1, activeColorScheme: activeColorScheme, ...otherProps, children: shouldCollapseOverflow ? (_jsx(OverflowCollapse, { renderOverflow: overflowRender ? overflowRender : () => renderOverflow(React.Children.toArray(children)), children: children })) : (children) }));
});
ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.defaultProps = {
    overflowLabel: "More"
};
